<template>
  <b-row>
    <b-col cols="12">
      <faq-add-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import FaqAddForm from './FaqAddForm.vue'

export default {
  components: {
    BRow,
    BCol,
    FaqAddForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
